import { FC } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { RRule } from 'rrule';
import { RouteComponentProps } from 'react-router-dom';
import { Segment } from '~src/interfaces/segment.interface';

import { PageContentContainer } from '~src/styles/containers.sc';
import { postObjective } from '~src/store/okrs/actions';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import { PostObjectiveApiBody, OkrLabel, PostKeyResultBody } from '~src/store/okrs/interfaces';

import { KeyResultAdd } from './keyResults/CreateKeyResults';
import ObjectiveAddForm, { ObjectiveFormData } from './ObjectiveAddForm';

interface DispatchProps {
  postObjective: (objective: PostObjectiveApiBody) => ApiReduxResp;
}

type Props = DispatchProps & RouteComponentProps;

function mapKeyResultAddToPostKeyResultBody(kr: KeyResultAdd): PostKeyResultBody {
  return {
    name: {
      en_US: kr.name,
    },
    min: +kr.startValue,
    max: +kr.targetValue,
    owners: kr.owners.map(owner => owner.id),
    weighting: kr.weighting,
  };
}

const ObjectiveAdd: FC<Props> = props => {
  const submitForm = (val: ObjectiveFormData) =>
    props.postObjective({
      name: { en_US: val.title },
      description: { en_US: val.description },
      start_date: moment.utc(val.start_date).format(),
      due_date: moment.utc(val.end_date).format(),
      visibility: val.visibility.key,
      owners: val.owners ? val.owners.map((owner: Segment) => owner.id) : [],
      labels: val.labels ? val.labels.map((label: OkrLabel) => label.id) : [],
      visibilities: val.visibility.people ? val.visibility.people.map((seg: Segment) => seg.id) : [],
      vis_owners_managers: !!val.visibility.shareWithManagers,
      status: val.status,
      reminder_options: val.repeat && RRule.fromString(val.repeat).options,
      key_results: Object.values(val.keyResults).map(mapKeyResultAddToPostKeyResultBody),
      subobjectives: val.subobjectives,
    });

  return (
    <PageContentContainer>
      <ObjectiveAddForm formSubmit={submitForm} />
    </PageContentContainer>
  );
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  postObjective: objective => dispatch(postObjective(objective)),
});

const ObjectiveAddConnected = connect(null, mapDispatchToProps)(ObjectiveAdd);
export default ObjectiveAddConnected;
